// extracted by mini-css-extract-plugin
export default {"li":"CategoryItem_li__POR+j","active":"CategoryItem_active__PVNAU","button":"CategoryItem_button__ujnAX","textIcon":"CategoryItem_textIcon__LYcsd","icon":"CategoryItem_icon__ZXjc6"};